<template>
  <b-modal
    id="delete-folder-modal"
    ref="modal"
    centered
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Delete')"
    :title="$t('Delete') + ' ' + $t('a') + ' ' + $t('operation.dossier')"
    cancel-variant="outline-primary"
    ok-variant="danger"
    @hidden="resetModal"
    @ok="handleOk">

    <div class="mb-2">
      {{ $t('DeleteFolderTitle') }} <span class="bold-text">"{{ folder.name }}"</span> ?
    </div>
    <div class="mb-4">
      {{ $t("DeleteFolderMessage") }}
    </div>
  </b-modal>
</template>

<script>
import api from '../../../services/api'

export default {

  name: 'DeleteFolderModal',
  props: {
    operationId: {
      default: false
    },
    folder: {
      default: {}
    }
  },

  data: function () {
    return {
    }
  },

  methods: {

    resetModal() {
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let formData = new FormData()
      formData.append('operationId', this.operationId)
      formData.append('folderId', this.folder.id)

      api({
        method: 'POST',
        url: `/operationDocument/deleteFolder`,
        data: formData
      })
        .then(() => {
          this.$emit('didAddFolder')
          this.successToast()
          this.hideModal()
        })
        .catch(() => {
          this.errorToast()
        })
    },

    hideModal() {
      this.$bvModal.hide('delete-folder-modal')
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('DeleteFolder.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('DeleteFolder.error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/operation/components/DeleteFolderModal.vue